<rask-page [headerShow]="false" noPadding>
    <rask-tabs parameterName="tab" class="mb-0 h-100 d-flex flex-column" aid="startTabs" layout="header" [size]="5"
        tabClass="h-100">
        <rask-tab label="Start" routeId="start" aid="startTab">
            @if (dashboardFeatureActive | async) {
            <ng-template #widgetError let-message="message">
                <rask-validation-message-row
                    type="error"
                    [message]="message">
                </rask-validation-message-row>
            </ng-template>
            <rask-dashboard [locked]="true" [unregisteredErrorTemplate]="widgetError">
            </rask-dashboard>
            }
            @else{
            <div [ngClass]="{'container': !isfirstPageFeatureActive}" class="top-content-block">
                <div class="row mt-5 justify-content-center">
                    @for (box of boxes; track box; let index = $index) {
                    @if (box.isActive) {
                    <div class="m-2"
                        [ngClass]="{'col-lg-3 col-md-6': !isfirstPageFeatureActive, 'col-lg-2 col-md-3 col-sm-4': isfirstPageFeatureActive}">
                        @if (box.href) {
                        <a [attr.aid]="box.aid"
                            [ngClass]="{'tile-width-original': !isfirstPageFeatureActive, 'tile-width-firstpagefeature': isfirstPageFeatureActive}"
                            class="rask-vit-panel thumbnail tile tile-medium border tilelink" [href]="box.href">
                            <ng-container *ngTemplateOutlet="boxPanel;context:{box:box}"></ng-container>
                        </a>
                        }
                        @if (box.state) {
                        <a [attr.aid]="box.aid" class="rask-vit-panel thumbnail tile tile-medium border tilelink"
                            [routerLink]="box.state">
                            <ng-container *ngTemplateOutlet="boxPanel;context:{box:box}"></ng-container>
                        </a>
                        }
                    </div>
                    }
                    }
                </div>
            </div>

            @if (isfirstPageFeatureActive) {
            <hr>
            }

            @if (isfirstPageFeatureActive) {
            <div class="container">
                <div class="row mt-3 pt-3 justify-content-center">
                    <div class="col-12">
                        <rask-recent></rask-recent>
                    </div>
                </div>
            </div>
            }

            <ng-template #boxPanel let-box="box">
                <div class="mb-2">
                    <h5 class="tilename">{{box.title}}</h5>
                    <i class="boxicon {{box.icon}}" aria-hidden="true"></i>
                </div>
                <div class="tiledescription">
                    {{box.description}}
                </div>
            </ng-template>
            }
        </rask-tab>

        @if (hasRaskTitta()) {
        <rask-tab [label]="handelseLabel" routeId="aoinfo" aid="aoInfoTab">
            <rask-start-handelser (numberOfErrors)="setNrOfErrors($event)"></rask-start-handelser>
        </rask-tab>
        }
        @if (hasRaskTitta()) {
        <rask-tab label="Aktiviteter" routeId="aktiviteter" aid="aktiviteter">
            <rask-start-aktiviteter></rask-start-aktiviteter>
        </rask-tab>
        }
    </rask-tabs>
</rask-page>
<rask-footer></rask-footer>